import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n/config'
import './index.css'
import { registerSW } from 'virtual:pwa-register'

if (import.meta.env.DEV) {
  import('./utils/devtools-expose')
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

declare global {
  interface Window {
    __ARCS_SW_READY__?: Promise<ServiceWorkerRegistration | undefined>
  }
}

if ('serviceWorker' in navigator) {
  window.__ARCS_SW_READY__ = new Promise((resolve) => {
    registerSW({
      immediate: true,
      onRegistered(registration) {
        if (import.meta.env.DEV) {
          console.info('[wallet-web] Service Worker registered', registration)
        }
        resolve(registration)
      },
      onRegisterError(error) {
        console.error('[wallet-web] Service Worker registration failed', error)
        resolve(undefined)
      },
    })
  })
}
